
import { defineComponent } from 'vue';
import { 
  IonPage, IonHeader, IonToolbar, IonTitle, IonContent, 
  IonButtons, IonMenuButton, IonIcon, IonItem, IonLabel, 
  IonTextarea, IonToggle, IonButton, IonSpinner, toastController,
  IonDatetime, IonSelect, IonSelectOption
} from '@ionic/vue';
import { 
  timeOutline, calendarOutline, documentTextOutline, personOutline, 
  checkmarkCircleOutline, listOutline, folderOpenOutline, locationOutline 
} from 'ionicons/icons';
import { pushFocus } from '../../pushNotifications';

export default defineComponent({
  name: 'ManualAttendanceApply',
  mixins: [pushFocus],
  components: {
    IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
    IonButtons, IonMenuButton, IonIcon, IonItem, IonLabel,
    IonTextarea, IonToggle, IonButton, IonSpinner,
    IonDatetime, IonSelect, IonSelectOption
  },
  setup() {
    return {
      timeOutline, calendarOutline, documentTextOutline, personOutline,
      checkmarkCircleOutline, listOutline, folderOpenOutline, locationOutline
    }
  },
  data() {
    return {
      config: null as any,
      loading: false,
      loadingHistory: false,
      form: {
        requested_date: '',
        type: '',
        time: '',
        is_field_visit: false,
        office_id: null as any,
        reason: ''
      },
      requests: [] as any[]
    }
  },
  computed: {
    // Manual attendance can only be requested for the past 30 days, never the future
    // (matches the leave module's back-dating window; backend enforces the same).
    dateMin(): string {
      const d = new Date();
      d.setDate(d.getDate() - 30);
      return d.toISOString().split('T')[0];
    },
    dateMax(): string {
      return new Date().toISOString().split('T')[0];
    }
  },
  mounted() {
    this.fetchUserConfig();
    this.fetchHistory();
  },
  methods: {
    reloadForPush() {
      this.fetchHistory();
    },
    async fetchUserConfig() {
      const data = {
        username: window.localStorage.username,
        password: window.localStorage.password,
      };
      this.$http.post('hr/getUserConfig', data, { skipLoading: true })
        .then(response => {
          if (response.data.status) {
            this.config = response.data.config;
            if (this.config && this.config.office) {
              this.form.office_id = this.config.office.id;
            }
          }
        }).catch(() => {});
    },
    async fetchHistory() {
      this.loadingHistory = true;
      const data = {
        username: window.localStorage.username,
        password: window.localStorage.password,
      };
      this.$http.post('hr/myManualAttendanceRequests', data, { skipLoading: true })
        .then(response => {
          if (response.data.status) {
            this.requests = response.data.data;
          }
          this.loadingHistory = false;
          // Opened from a notification (approved / declined): show that request.
          this.focusPushCard();
        }).catch(() => { this.loadingHistory = false; });
    },
    async submitRequest() {
      if (!this.form.type) {
        const toast = await toastController.create({
          message: 'Please select a Request Type (Check In or Check Out).',
          duration: 3000,
          color: 'danger'
        });
        toast.present();
        return;
      }
      
      this.loading = true;
      let reqDate = this.form.requested_date;
      if (reqDate && reqDate.includes('T')) {
        reqDate = reqDate.split('T')[0];
      }
      
      let reqTime = this.form.time;
      if (reqTime && reqTime.includes('T')) {
        const dateObj = new Date(reqTime);
        reqTime = dateObj.toTimeString().split(' ')[0];
      }

      const data = {
        username: window.localStorage.username,
        password: window.localStorage.password,
        ...this.form,
        requested_date: reqDate,
        time: reqTime
      };
      
      this.$http.post('hr/manualAttendanceRequest', data)
        .then(async (response) => {
          this.loading = false;
          if (response.data.status) {
            const toast = await toastController.create({
              message: 'Request submitted successfully.',
              duration: 2000,
              color: 'success'
            });
            toast.present();
            this.form.reason = '';
            this.form.time = '';
            this.fetchHistory();
          } else {
            const toast = await toastController.create({
              message: response.data.message || 'Error submitting request.',
              duration: 3000,
              color: 'danger'
            });
            toast.present();
          }
        })
        .catch(async () => {
          this.loading = false;
          const toast = await toastController.create({
            message: 'Server error. Try again.',
            duration: 3000,
            color: 'danger'
          });
          toast.present();
        });
    },
    getStatusBadgeClass(status: string) {
      if (status === 'approved') return 'badge-success';
      if (status === 'rejected') return 'badge-danger';
      return 'badge-warning';
    }
  }
});
